// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"Select_customSelect__JFPH6","label":"Select_label__M45G1"};